"use client";

import { Navbar } from "home/Navbar";
import { UploadResume } from "../score-check/components/UploadResume";
import { useEffect, useState } from "react";
import { redirect, useRouter } from "next/navigation";
import { ToastContainer } from "react-toastify";
import { useAppSelector } from "lib/redux/hooks";
import { selectResume } from "lib/redux/resumeSlice";
import { setResumeCache } from "../score-check/utils/localStorageHelper";
import { selectAccessToken, selectIsAuthenticationOpen, setIsAuthenticationOpen } from "lib/redux/uiSlice";
import { AuthenticationOptions } from "components/AuthenticationOptions";
import { useDispatch } from "react-redux";

const UploadResumePage = () => {

  const [hasUploadedResume, setHasUploadedResume] = useState(false);
  const router = useRouter();
  const resume = useAppSelector(selectResume);
  const isAuthenticationOpen = useAppSelector(selectIsAuthenticationOpen);
  
  const dispatch = useDispatch();

  // Watch for resume upload and navigate to the next step when it happens
  useEffect(() => {
    
    if (hasUploadedResume && resume) {
      // Store the resume in localStorage for future steps
      setResumeCache({resume});
      // Navigate to the next step
      router.push('/select-experience');
    }
  }, [hasUploadedResume, resume, router]);

  return (
    <main className="relative h-screen w-full overflow-hidden bg-[#F1F1F1]">
      <Navbar />
      <div className="flex h-full flex-col items-center justify-center pb-20">
        <UploadResume setHasUploadedResume={setHasUploadedResume} />
      </div>
      {isAuthenticationOpen && <AuthenticationOptions redirectTo="/upload-resume"/>}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </main>
  );
};

export default UploadResumePage;